import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { WORDING_FILES } from '../defines/defines';

import { ConfigLoaderService } from '../services/config-loader.service';

/** CustomTranslateLoader */
export class CustomTranslateLoader extends TranslateHttpLoader {
    private customHttp;
    private config;
    public constructor (http: HttpClient, configLoaderService: ConfigLoaderService, prefix?: string, suffix?: string) {
        super(http, prefix, suffix);
        this.customHttp = http;
        this.config = configLoaderService;
    }

    /** getTranslation */
    public override;
    /** getTranslation */
    public getTranslation (lang: string) {
      if (lang === WORDING_FILES.defaultWording) {
          return this.config.getDefaultGermanWordingFile();
      } else if (lang === WORDING_FILES.deWording) {
          return this.config.getDeWordingFile();
      } else {
        return this.config.getDefaultGermanWordingFile();
      }
  }

}
